import { useUserStore } from "~/stores/auth";
import { useChannelsStore } from "~/stores/channels";

interface Channel {
  channelId: number;
}

interface ChannelsStore {
  channels: Channel[];
}

interface AuthStore {
  user: unknown;
}

export default defineNuxtRouteMiddleware((to, _from) => {
  const channelsStore = useChannelsStore() as unknown as ChannelsStore;
  const authStore = useUserStore() as unknown as AuthStore;

  if ("channelId" in to.params && authStore.user) {
    // check if any of the user's channels match the route channel id
    const hasAccess = channelsStore.channels?.some(
      (channel) => channel.channelId === Number(to.params.channelId)
    );

    // if not, bounce him back to home.
    // there are other middlewares that check for 403 access,
    // or for nonEecUser status, so this is just for channels the user has no access to.
    if (!hasAccess) {
      return navigateTo('/');
    }
  }
  return undefined;

});
